import { UserEngagementPinger } from '.';
import { renderCompAndReturnUnmount } from '../utils';
export function renderUserEngagementPingerAndReturnUnmount(elem, props) {
    return renderCompAndReturnUnmount(elem, UserEngagementPinger, props);
}
//# sourceMappingURL=renderer.js.map